import Footer from "./footer/Footer";
import Iconsection from "./iconSection/Iconsection";
import ServiceCards from "../ServicesCards/ServiceCads";
import MainSlider from "./Main Slider/MainSlider";
import TeamMembors from "./SIEteam/TeamMembors";
import ImageSlider from "../ImagesSlider/ImageSlider";
import SundarMap from "../SundarMap/SundarMap";
const MainDashboard = () => {
  return (
    <>
      <MainSlider />
      <ImageSlider />
      <Iconsection />
      <ServiceCards />
      <TeamMembors />
      <SundarMap />
      <Footer />
    </>
  );
};
export default MainDashboard;
